import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class updateLetterService {

  constructor(public http: HttpClient) { }

  public getTemplateList(acronym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/getTemplateList`);
  }

  public generateLetter(appId, paylaod,acronym):Observable<any>{
    return this.http.post(environment.BASE_URL_DES+`${acronym}/generateLetter/`+appId,paylaod)
  }


  public updateLetter(paylaod,acronym):Observable<any>{
    return this.http.post(environment.BASE_URL_DES+`${acronym}Admin/updateLetterForApplicant`,paylaod)
  }
}
